import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EnvService } from 'src/app/env.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {



  //  baseUrl = environment.apiUrl;
  baseUrl = environment.production === true ? this.env.apiUrl : environment.apiUrl;
  provincesUrl = environment.production === true ? this.env.provincesUrl : environment.provincesUrl;

  constructor(private env: EnvService, private http: HttpClient ) { } 
   
  getAll(  CompanyCode: string, StoreId: string, User: string,  Type: string,  FromDate: string, ToDate: string ): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'log/GetAll?companyCode=' + CompanyCode  + '&StoreId=' + StoreId+ '&User=' + User + '&Type=' + Type+ '&FromDate=' + FromDate+ '&ToDate=' + ToDate );
  }
  GetAreaRegis( ): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'api/BM/GetAreaRegis' );
  }
  GetAgentInMap( ): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'api/Company/GetAgentInMap' );
  }
  RegisBM( model: any) {
    return this.http.post(this.baseUrl + 'api/BM/PostBM', model  );
  }
  RegisAgent(model: any)
  {
    return this.http.post(this.baseUrl + 'api/AgentProfile/CreateAgent', model);
  }
  Login(username: string, password: string) {
    // SECURITY: credentials are sent in the POST body (over HTTPS), never in the
    // query string where they would be logged by proxies/servers/browser history.
    // Isolated, secured agent-landing endpoint (parameterized SQL + bearer-token
    // auth) — replaces the shared, anonymous GET api/User/GetUserAgent. Returns
    // { result, data, token }.
    return this.http.post<any>(this.baseUrl + 'api/AgentReport/Login', { username, password });
  }
  GetProvinces(): Observable<any>
  {
    return this.http.get<any>(this.provincesUrl + 'api/?depth=2');
  }
  GetData(CreatedFrom: string ): Observable<any>
  {
    // Isolated, secured agent-landing endpoint ([BmAuthorize] bearer token; the
    // AuthInterceptor attaches it). CreateFrom='AGW' is forced server-side, so the
    // client value is no longer sent. Replaces the anonymous GET api/AgentProfile/GetAgentProfileList.
    return this.http.get<any>(this.baseUrl + 'api/AgentReport/GetAgentProfileList');
  }
  // GetAreaRegis( ): Observable<any> {
  //   return this.http.get<any>(this.baseUrl + 'api/BM/GetAreaRegis' );
  // }
  // create(model: SLog) {
    
  //   return this.http.post(this.baseUrl + 'log/create', model );
  // }

    
  // update(model: SLog) {
  
  //   return this.http.put(this.baseUrl + 'log/update', model);
  // }


}
